import { gql } from "@apollo/client";

export const updateThreadBubbleStatus = gql`
  mutation UpdateThreadBubbleStatus($ids: [ID]!) {
    updateThreadBubbleStatus(ids: $ids)
  }
`;

export const sendPlaceItOfferMessage = gql`
  mutation SendTheadMessage(
    $offerId: ID!
    $message: String
    $brokerFirstname: String
    $brokerLastname: String
  ) {
    sendTheadMessage(
      offer_id: $offerId
      message: $message
      broker_firstname: $brokerFirstname
      broker_lastname: $brokerLastname
    ) {
      message
    }
  }
`;

export const archiveMessageThread = gql`
  mutation ArchiveMessageThread($offerID: ID!, $email: String) {
    archiveMessageThread(offer_id: $offerID, email: $email)
  }
`;
